import { render, staticRenderFns } from "./editPurchaseRequisition.vue?vue&type=template&id=fd7452b0&scoped=true"
import script from "./editPurchaseRequisition.vue?vue&type=script&lang=js"
export * from "./editPurchaseRequisition.vue?vue&type=script&lang=js"
import style0 from "./editPurchaseRequisition.vue?vue&type=style&index=0&id=fd7452b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7452b0",
  null
  
)

export default component.exports